module.exports = __webpack_public_path__ + "img/TREASURY.c2a04a7f.svg";